import {
  CapaServiceType,
  FetchWithdrawnChatRoomsInput,
  useFetchWithdrawnChatRoomsQuery
} from '@generated/graphql';
import { useMediaQuery, useTheme } from '@material-ui/core';
import getScopes from '@utils/getScopes';
import React from 'react';
import { useHistory } from 'react-router-dom';
import ConfirmChat from './ConfirmChat';
import ConfirmMembership from './ConfirmMembership';
import ConfirmPassword from './ConfirmPassword';
import MemberShipWithdrawalPresenter from './MemberShipWithdrawalPresenter';
import useWithdrawalStage from './useWithdrawalStage';
const MemberShipWithdrawalContainer = () => {
  const history = useHistory();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const [stage, setStage] = useWithdrawalStage();

  const { scopes } = getScopes();

  const isConnect = scopes.some((v) => v === CapaServiceType.Connect);

  const { data, refetch } = useFetchWithdrawnChatRoomsQuery({
    variables: {
      input: {
        serviceType: CapaServiceType.Quotation
      }
    }
  });

  const totalCount = (
    data?.fetchWithdrawnChatRooms.data?.consultingChatRoomsCount ?? []
  )
    .filter((room) => room.capaService !== CapaServiceType.Connect)
    .map((room) => {
      return room.totalCount ?? 0;
    })
    .reduce((prev, curr) => prev + curr, 0);

  const connectGroupCount = (
    data?.fetchWithdrawnChatRooms.data?.consultingChatRoomsCount ?? []
  )
    .filter((room) => room.capaService === CapaServiceType.Connect)
    .map((room) => {
      return room.totalCount ?? 0;
    })
    .reduce((prev, curr) => prev + curr, 0);

  const getChatRoom = async (variables: FetchWithdrawnChatRoomsInput) => {
    await refetch({ input: { ...variables } });
  };

  const onChangeRoute = (path: string) => {
    window.scrollTo({ top: 0 });

    return history.push(path);
  };

  const isExistChatRooms = totalCount + connectGroupCount !== 0;

  return (
    <MemberShipWithdrawalPresenter
      matches={matches}
      stage={stage}
      isConnect={isConnect}
      totalCount={totalCount}
      connectGroupCount={connectGroupCount}
    >
      {stage === 'confirm-password' && (
        <ConfirmPassword matches={matches} setStage={setStage} />
      )}
      {stage === 'confirm-membership' && (
        <ConfirmMembership
          matches={matches}
          isExistChatRooms={isExistChatRooms}
          setStage={setStage}
          onChangeRoute={onChangeRoute}
        />
      )}
      {stage === 'confirm-chat' && (
        <ConfirmChat
          matches={matches}
          data={data}
          setStage={setStage}
          getChatRoom={getChatRoom}
          onChangeRoute={onChangeRoute}
        />
      )}
      {stage === 'complete'}
    </MemberShipWithdrawalPresenter>
  );
};

export default MemberShipWithdrawalContainer;
